import { FC } from 'react'

import styled from 'styled-components'

import { PrimaryRadio } from 'src/Components/PrimaryRadio'
import { variables } from 'src/Styled/variables'

export const ItemTitle = styled.span`
  font-family: Segoe UI;
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const RadioContainer = styled.div<{
  $disabled?: boolean
  $checked?: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 12px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  padding: 16px 16px 12px 16px;
  border-radius: 16px;
  border: 1px solid
    ${({ theme, $checked }) =>
      $checked ? theme.color.brandGreen : theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  justify-content: center;
  max-width: 600px;
  min-width: 288px;
  width: 100%;
`

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;
  align-items: start;
`

const StyledRadio = styled(PrimaryRadio)`
  margin: 0;
`

const RadioDescriptionContainer = styled.div<{
  $disabled?: boolean
}>`
  display: flex;
  flex-direction: column;
  gap: 3.5px;
  color: ${({ theme, $disabled }) =>
    $disabled ? theme.color.mediumGrey : theme.color.darkGrey};
`

interface AdsPlacementsRadioItemProps {
  checked: boolean
  title?: string
  description?: React.ReactNode
  disabled?: boolean
  onClick?: () => void
}

export const AdsPlacementsRadioItem: FC<AdsPlacementsRadioItemProps> = ({
  checked,
  title,
  description,
  disabled,
  onClick,
}) => (
  <RadioContainer
    $disabled={disabled}
    $checked={checked}
    onClick={disabled ? () => {} : onClick}
  >
    <OptionWrapper>
      <StyledRadio checked={checked} disabled={disabled} onClick={onClick} />
      <RadioDescriptionContainer $disabled={disabled}>
        <ItemTitle>{title}</ItemTitle>
        <span>{description}</span>
      </RadioDescriptionContainer>
    </OptionWrapper>
  </RadioContainer>
)
